import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "loading",
  style: {"position":"absolute","top":"15%","height":"90%"}
}
const _hoisted_2 = {
  class: "d-flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8",
  style: {"height":"80%","background-color":"rgba(150, 150, 150, 0.7)"}
}
const _hoisted_3 = { class: "max-w-md w-full space-y-8" }

import i18n from '@/lang/i18n';
import vLoaderAnimation from '@/components/template/v-loader-animation.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'LoadingAnimation',
  props: {
    loading: { type: Boolean }
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(vLoaderAnimation, {
          text: 'text-white',
          "loading-text-style": 'text-black text-lg',
          "loading-text": _unref(i18n).global.t('common.loadingText'),
          addCharacterImg: false
        }, null, 8, ["loading-text"])
      ])
    ])
  ], 512)), [
    [_vShow, props.loading]
  ])
}
}

})